// Lib
import React, { forwardRef } from 'react';
import { LoadingButton } from '@mui/lab';

// Styles
import { useStyles } from './ButtonStyles';

const Button = forwardRef(function Button(
  { variant = 'contained', children, styles, className, ...props },
  ref,
) {
  const { classes, cx } = useStyles({ styles });

  return (
    <LoadingButton
      {...props}
      className={cx(classes.button, className)}
      variant={variant}
      ref={ref}>
      {children}
    </LoadingButton>
  );
});

export default Button;
